<template>
  <v-container fluid>
    <div class="control-tabs">
      <div v-for="(tab, key) in tabs" :key="key" class="control-tabs__tab"
        :class="{ 'control-tabs__tab--active': tab.active }" @click="toggleTab(key)">
        {{ tab.label }}
        <img v-if="tab.active" src="/static/img/control/tablo_on_blue.svg" alt="active" />
        <img v-else src="/static/img/control/tablo_off_grey.svg" alt="inactive" />
      </div>
    </div>
    <div class="control-blocks">
      <div v-if="tabs.employees.active || tabs.flights.active || tabs.telegram.active" class="control-blocks__col">
        <Employees v-if="tabs.employees.active" :loading="getControlsPreloader" />
        <Flights1 v-if="tabs.flights.active" :loading="getControlsPreloader" />
        <Flights2 v-if="tabs.flights.active" :loading="getControlsPreloader" />
        <Telegram v-if="tabs.telegram.active" :loading="getControlsPreloader" />
      </div>
      <div v-if="tabs.services.active" class="control-blocks__col">
        <Services2 v-if="tabs.services.active" :loading="getControlsPreloader" />
        <Services1 v-if="tabs.services.active" :loading="getControlsPreloader" />
      </div>
    </div>
  </v-container>
</template>

<script setup>
import { ref, computed } from 'vue'
import store from '@/store'
import Employees from '../Control/Employees.vue';
import Flights1 from '../Control/Flights1.vue';
import Flights2 from '../Control/Flights2.vue';
import Telegram from '../Control/Telegram.vue';
import Services1 from '../Control/Services1.vue';
import Services2 from '../Control/Services2.vue';

// Реактивное состояние
const tabs = ref({
  employees: { label: "Сотрудники", active: true },
  flights: { label: "Рейсы", active: true },
  services: { label: "Сервисы", active: true },
  telegram: { label: "Телеграммы", active: true },
})

// Методы
const toggleTab = (key) => {
  tabs.value[key].active = !tabs.value[key].active
}

// Вычисляемые свойства
const getControlsPreloader = computed(() => store.getters['controls/getControlsPreloader'])
const incomes = computed(() => store.getters['incomes/getControls'])
</script>
